import { render, staticRenderFns } from "./ClientDrawer.vue?vue&type=template&id=2584c4d0"
import script from "./ClientDrawer.vue?vue&type=script&lang=ts"
export * from "./ClientDrawer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports